export function postsSlider() {
    $(".posts-slider").slick({
        slidesToScroll: 1,
        prevArrow: '<button class="slick-prev slick-arrow" aria-label="Next" type="button" style=""><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M14 19.5382L12.463 21L3 12L12.463 3L14 4.46179L7.12542 11H21V13H7.12542L14 19.5382Z" fill="#2B2B2B"/>\n' +
        '</svg></button>',
        nextArrow: '<button class="slick-next slick-arrow" aria-label="Previous" type="button" style=""><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">\n' +
        '<path d="M10 19.5382L11.537 21L21 12L11.537 3L10 4.46179L16.8746 11H3V13H16.8746L10 19.5382Z" fill="#2B2B2B"/>\n' +
        '</svg></button > ',
        mobileFirst: true,
        responsive: [
            {
                breakpoint: 567,
                settings: {
                    slidesToShow: 1
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 1023,
                settings: {
                    slidesToShow: 3
                }
            }
        ]
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/postsSlider.js